module.exports = __webpack_public_path__ + "static/media/30-3.304fda57.mp3";